export const WORKSPACE_STORAGE_KEY = 'current_workspace_id';
